import React, { useEffect, useState } from "react";
import "./Footer.scss";
import { HEADER_FOOTER_QUERY } from "../../services/query";
import { useQuery } from "@apollo/client/react";
import { IMasterData, MasterDataItem, errorModel } from "../../context/model";
import { useAppContext } from "../../provider/AppContextProvider";
import { NavLink } from "react-router-dom";
import { logger } from "../../services/logger";
import { REACT_APP_WUCA_DXP_ADMIN_URL } from "../../services/config";
import LazyImage from "../LazyImage";
import { useFetchKeyContactData } from "../../hooks/usefetchKeyContactData";

function Footer() {
  const { updateLoading, isInitializing } = useAppContext();
  const [footer, setFooter] = useState<MasterDataItem[]>([]);
  
  const { getEmailAddresses } = useFetchKeyContactData();
  
  const { error, data, loading } = useQuery<IMasterData>(HEADER_FOOTER_QUERY, {
    skip: isInitializing,
  });

  useEffect(() => {
    if (data) {
      setFooter(data?.cAMasterDataCollection?.items);
    }

    if (error) {
      updateLoading(false, "footernLoading");
      const errorModel: errorModel = {
        type: "Error",
        source: "Footer.tsx",
        error: `${error.message}\n${error.stack}\n${error.name}`,
        eventCode: "Footer",
      };
      logger.logToApi(errorModel);
      logger.logToAppInsights(error as Error, 3);
      setFooter([]);
    }
  }, [data, error]);

  // Effect to handle loading states
  useEffect(() => {
    updateLoading(loading, "footerLoading");
  }, [loading]);

  return (
    <>
      {footer.length === 0 ? (
        <></>
      ) : (
        <footer>
          {footer.map((item, index) => (
            <div className="footer" key={index}>
              <div className="footer-top-container">
                <div className="footer-logo">
                  <a target="_blank" href={item.footerLogoUrl}>
                    <LazyImage
                      src={`${REACT_APP_WUCA_DXP_ADMIN_URL}${item?.imageContentHubFooterLogo?.items?.[0]?.contentFile?.path}`}
                      alt="Logo"
                    />
                  </a>
                </div>
                <div className="footer-social-icon">
                  {getEmailAddresses() && (
                    <a
                      className="fa-kit fa-mail"
                      href={`mailto:${getEmailAddresses()}`}
                      title="Email"
                      rel="noreferrer"
                    ></a>
                  )}
                  <a
                    className="fa-kit fa-facebook-square"
                    target="_blank"
                    href={item.facebookNavigation}
                    title="facebook"
                    rel="noreferrer"
                  ></a>
                  <a
                    className="fa-kit fa-youtube-square"
                    target="_blank"
                    href={item.youtubeNavigation}
                    title="youtube"
                    rel="noreferrer"
                  ></a>
                  <a
                    className="fa-kit fa-instagram-square"
                    target="_blank"
                    href={item.instagramNavigation}
                    title="instagram"
                    rel="noreferrer"
                  ></a>
                  <a
                    className="fa-kit fa-social-linkedin"
                    target="_blank"
                    href={item.linkedInNavigation}
                    title="linkedIn"
                    rel="noreferrer"
                  ></a>
                </div>
              </div>
              <hr />
              <div className="footer-bottom-container">
                <div className="lol-logo">
                  <LazyImage
                    src={`${REACT_APP_WUCA_DXP_ADMIN_URL}${item?.imageContnetHubFooterContentLogo?.items?.[0]?.contentFile?.path}`}
                    alt="Footer-Logo"
                  />
                </div>
                <div
                  className="footer-content"
                  dangerouslySetInnerHTML={{ __html: item.footerText.replace("##YEAR##", new Date().getFullYear().toString()) }}
                />
              </div>
            </div>
          ))}
        </footer>
      )}
    </>
  );
}
export default Footer;
                 